import { FETCH_ALL_TRANSFERS, FETCH_PAGINATE_TRANSFERS, FETCH_CURRENT_TRANSFER } from './../../mutation-types';

export default {
  [FETCH_ALL_TRANSFERS](state, transfers) {
    state.all = transfers;
  },

  [FETCH_PAGINATE_TRANSFERS](state, { transfers, pagination }) {
    state.items = transfers;
    state.pagination = pagination;
  },

  [FETCH_CURRENT_TRANSFER](state, transfer) {
    state.currentTransfer = transfer;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/transfer/mutations.js